import { useState } from 'react'
import { Modal } from './Modal.tsx'
import { Button } from './ui.tsx'

export function ConfirmDialog({ title, body, confirmLabel, danger, onConfirm, onClose }: {
  title: string
  body: string
  confirmLabel: string
  danger?: boolean
  onConfirm: () => Promise<void>
  onClose: () => void
}) {
  const [busy, setBusy] = useState(false)

  async function run() {
    setBusy(true)
    try { await onConfirm(); onClose() } finally { setBusy(false) }
  }

  return (
    <Modal
      title={title}
      onClose={busy ? () => {} : onClose}
      footer={
        <>
          <Button onClick={onClose} disabled={busy}>Cancel</Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={run} loading={busy}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="muted" style={{ lineHeight: 1.6 }}>{body}</p>
    </Modal>
  )
}
